import React from "react";
import "./style.scss";

const Card = ({ tag, title, cardBtn, cardImg, aos }) => {
  return (
    <div className="card" data-aos={aos}>
      <div className="header">
        <div className="text">
          <span>{tag}</span>
          <h3>{title}</h3>
        </div>
        <div className="card-btn">{cardBtn}</div>
      </div>
      <div className="card-img">
        <img src={cardImg} alt="card-img" />
      </div>
    </div>
  );
};

export default Card;
